import { Outlet } from "react-router-dom";
import Sidebar from "./Bridge/Sidebar";
import BaseCom from "./BaseCom";
import CheckVer from "./CheckVer";
import Auth from "../shared/Auth";
import Tick from "./Tick";
import { withParamsAndNavigate } from "./WithParamsAndNavigate";

class ConsoleLayout extends BaseCom {

    componentDidMount() {
        this.checkUser(false);
    }
    
    onSidebarToggle = (on) => {
        this.setState({ sidebarToggle: on });
    }

    checkUser = async (force) => {
        try {
            let u = await Auth.getLoginAsync(force);
            if (!u) {
                Auth.reset();
                this.props.navigate('/login');
            }
        }
        catch (e) {
            console.error(e);
        }
    }

    render() {
        return (
            <main className={this.state.sidebarToggle ? 'main-nav-open' : 'main-nav-close'}>
                <CheckVer />
                <Tick interval={10000} onTick={() => this.checkUser(true)} />
                <Sidebar navigate={this.props.navigate} onSidebarToggle={this.onSidebarToggle} />
                <div className="c-pagewrapper">
                    <Outlet />
                </div>
            </main>
        )
    }
}

export default withParamsAndNavigate(ConsoleLayout);